// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:where(.vuetify-styles) .v-date-picker {
  overflow: hidden;
  width: 328px;
  --v-date-picker-landscape-header-width: 170px;
}
:where(.vuetify-styles) .v-date-picker--show-week {
  width: 368px;
}
:where(.vuetify-styles) .v-date-picker.v-picker--landscape:has(.v-picker__header-wrapper) {
  width: calc(328px + var(--v-date-picker-landscape-header-width));
}
:where(.vuetify-styles) .v-date-picker.v-picker--landscape:has(.v-picker__header-wrapper) .v-picker__header-wrapper {
  width: var(--v-date-picker-landscape-header-width);
}
:where(.vuetify-styles) .v-date-picker.v-picker--landscape:has(.v-picker__header-wrapper) .v-picker__header-wrapper .v-date-picker-header {
  height: auto;
  padding-inline: 24px;
}
:where(.vuetify-styles) .v-date-picker.v-picker--landscape:has(.v-picker__header-wrapper).v-picker--show-week {
  width: calc(368px + var(--v-date-picker-landscape-header-width));
}
:where(.vuetify-styles) .v-date-picker > .v-picker__body {
  flex-direction: column;
}`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/lib/components/VDatePicker/VDatePicker.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,YAAY;EACZ,6CAA6C;AAC/C;AACA;EACE,YAAY;AACd;AACA;EACE,gEAAgE;AAClE;AACA;EACE,kDAAkD;AACpD;AACA;EACE,YAAY;EACZ,oBAAoB;AACtB;AACA;EACE,gEAAgE;AAClE;AACA;EACE,sBAAsB;AACxB","sourcesContent":[".v-date-picker {\n  overflow: hidden;\n  width: 328px;\n  --v-date-picker-landscape-header-width: 170px;\n}\n.v-date-picker--show-week {\n  width: 368px;\n}\n.v-date-picker.v-picker--landscape:has(.v-picker__header-wrapper) {\n  width: calc(328px + var(--v-date-picker-landscape-header-width));\n}\n.v-date-picker.v-picker--landscape:has(.v-picker__header-wrapper) .v-picker__header-wrapper {\n  width: var(--v-date-picker-landscape-header-width);\n}\n.v-date-picker.v-picker--landscape:has(.v-picker__header-wrapper) .v-picker__header-wrapper .v-date-picker-header {\n  height: auto;\n  padding-inline: 24px;\n}\n.v-date-picker.v-picker--landscape:has(.v-picker__header-wrapper).v-picker--show-week {\n  width: calc(368px + var(--v-date-picker-landscape-header-width));\n}\n.v-date-picker > .v-picker__body {\n  flex-direction: column;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
